import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router, NavigationExtras, NavigationEnd } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { retry, catchError , map} from "rxjs/operators";
import * as moment from 'moment-timezone';
import { Location } from "@angular/common";
import { ToastrManager } from "ng6-toastr-notifications"


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  
  baseUrl =  'https://hvf.appmaister.com/v1/user';
  // baseUrl ='https://dev-https://hvf.consagous.co.in/api/v1/user';
  
  constructor(
    public http: HttpClient,
    private router: Router,
    private location: Location,
    public toastr: ToastrManager,
  ) {}

  // Http Options
  getHeaderLogin(type = 2) {
    var data:any = "";    
    if (type == 1) {
      return {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    } else {
      return {
        headers: new HttpHeaders({
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    }
  }
  // Http Options
  getHeadersLogin() {
    var data :any= "";   
    return {
      headers: new HttpHeaders({
        //'Content-Type' : 'application/json, text/plain, */*',
        "X-Authorization":  data,
        "device-type": "Browser",
        "device-token": "8745",
        "Version": "1.0.0",
        "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        // 'lat':lat,
        // 'long':lang,
        // 'userid':currentUserId,
        // 'parentId':parentid,
        // 'timeZone':moment.tz.guess(),
        // 'timeZoneOffset':'',
        // 'role':role_id,
      }),
    };
  }

  // Common post api
  PostApis(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.router.navigate(['/signin']);
        }
      }    
      return data;
    }))
  }

  // Common get api
  GetApi(url: any) {
    return this.http
      .get<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.router.navigate(['/signin']);
        }
      }    
      return data;
    }))
  }


  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

    // successAlert for fire toast/...
    successAlert(msg: any) {
      this.toastr.successToastr(msg, " ", {
        position: "top-right",
        toastTimeout:2000
      });
    }
  
    warningAlert(msg: any) {
      this.toastr.warningToastr(msg, " ", {
        position: "top-right",
        toastTimeout:2000
      });
    }
  
    // successAlert for fire toast/...
    dangerAlert(msg: any) {
      this.toastr.errorToastr(msg, " ", {
        position: "top-right",
        toastTimeout:2000
      });
    }

}
